import React, {useContext, useEffect, useState} from 'react';
import {storage} from "../lib/storage";
import { message, Button, Space } from 'antd';
import {apiUrl} from "../config";
import axios from 'axios';


export const ApiContext = React.createContext(null);

export function useApi() {
    return useContext(ApiContext);
}

export default function ApiProvider(props) {

    const [user, setUser] = useState(null);
    let [toast, setToast] = useState({type: "", message: "", show: false})
    let [smsText, setSmsText] = useState(" ");


    useEffect(()=> {
        if(storage.get('user')){
            let converted = storage.get('user');
            setUser(converted);
        }
    }, []);

    const api = {
        get : (endPoint, params) => {

            let url = new URL(apiUrl  + endPoint)
            url.search = new URLSearchParams(params);

            return new Promise(function(resolve, reject) {
                return fetch(url, {
                    method: 'GET',
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "auth-token" : user ? "Bearer "+user.token : null,
                    },
                    mode: 'cors',
                    params: JSON.stringify(params)
                }).then(async resp => {
                    if (resp.status === 200 || resp.status === 201) {
                        resolve((await resp.json()));
                    } else {
                        throw (await resp.json());
                    }
                }).catch(error => {
                    globalErrorHandling(error);
                    reject(error);
                    return error;
                });
            });
        },
        post : (endPoint, params) => {
            return new Promise(function(resolve, reject) {
                return fetch(apiUrl + endPoint, {
                    method: 'POST', // or 'PUT'
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        "auth-token" : user ? "Bearer "+user.token : null,
                    },
                    body: JSON.stringify(params),
                }).then(async resp => {
                    console.log(resp, 'resp')
                    if (resp.status === 200 || resp.status === 201) {
                        resolve((await resp.json()));
                    } else {
                        throw (await resp.json());
                    }
                }).catch(error => {
                    globalErrorHandling(error);
                    if(error.status){
                        reject(error);
                    }else{
                        reject({status: false, message :error.message, error: null});
                    }
                    return error;
                });
            });
        },
        put : (endPoint, params) => {
            return new Promise(function(resolve, reject) {
                return fetch(apiUrl + endPoint, {
                    method: 'PUT', // or 'PUT'
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        "auth-token" : user ? "Bearer "+user.token : null,
                    },
                    body: JSON.stringify(params),
                }).then(async resp => {
                    if (resp.status === 200 || resp.status === 201) {
                        resolve((await resp.json()));
                    } else {
                        throw (await resp.json());
                    }
                }).catch(error => {
                    globalErrorHandling(error);
                    reject(error);
                    return error;
                });
            });
        },

        delete : (endPoint, params) => {
            return new Promise(function(resolve, reject) {
                return fetch(apiUrl + endPoint, {
                    method: 'DELETE', // or 'PUT'
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        "auth-token" : user ? "Bearer "+user.token : null,
                    },
                    body: JSON.stringify(params),
                }).then(async resp => {
                    if (resp.status === 200 || resp.status === 201) {
                        resolve((await resp.json()));
                    } else {
                        throw (await resp.json());
                    }
                }).catch(error => {
                    globalErrorHandling(error);
                    reject(error);
                    return error;
                });
            });
        },

        upload : (endPoint, params) => {
            return new Promise(function(resolve, reject) {
                return axios({
                    method: 'post',
                    url: apiUrl + endPoint ,
                    data: params,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        "auth-token" : user ? "Bearer "+user.token : null,
                    }
                }).then(async resp => {
                    if (resp.status === 200 || resp.status === 201) {
                        resolve((await resp));
                    } else {
                        throw (await resp);
                    }
                }).catch(error => {
                    globalErrorHandling(error);
                    reject(error);
                    return error;
                });
            });
        },

    };

    async function login(data) {
        storage.set('user', data);
        setUser(data);
    }

    function isLogin() {
        return Boolean(user);
    }

    function isManager(){
        return false;
    }

    function logout() {
        setUser(null);
        storage.remove("user");

    }

    function openToast(type, data) {
        if(type === "error"){
            message.error(data);
        }else if(type === "success"){
            message.success(data);
        }else if(type === "warning"){
            message.warning(data);
        }else{
            message.error(data);
        }

    }

    function updateSmsText(value) {
        setSmsText(value);
    }

    function getSmsText() {
        return smsText;
    }

    function globalErrorHandling(error) {
        openToast("error", error.message);
    }

    function successHandling(message) {
        openToast("success", message);
    }

    function getVersion() {
        return "1.0.0";
    }

    return (
        <ApiContext.Provider value={{api, user, successHandling, getVersion, isLogin, login, logout, openToast, isManager, getSmsText, updateSmsText}}>
            {props.children}
        </ApiContext.Provider>
    );
}
